// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5943) return "static/chunks/5943-69ddced8e6bf95db.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1106 ? "13adf9a2" : chunkId) + "." + {"1106":"3f40e570437d9d01","4593":"b1349cb084f989f8","6974":"b7323785bd47263e"}[chunkId] + ".js";
};